import React from "react";
import { CssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom";

/**
 * Wrapper for all /manage routes. Every manager surface — the dashboard
 * (/manage), the create flow (/manage/create/ai/*), and the per-game shell
 * (/manage/game/:id/*) — brings its own header via <ManagerHeader>. There is no
 * separate marketing AppBar here; rendering one produced a double header.
 */
const ManagerWrapper = () => (
  <>
    <CssBaseline />
    <Outlet />
  </>
);

export default ManagerWrapper;
